import registrationInstance from '../instance'

const fetchUser = () => {
  return registrationInstance.get('/users/self')
}

export default fetchUser
